import { Flex } from 'foundations-components/components/Flex';
import { MultiLevelDropdown } from 'foundations-components/transitional/components/Dropdown';
import { usePageLinks } from '../hooks/usePageLinks';
import { Button } from 'foundations-components/transitional/components/Button';
import { Link } from 'foundations-components/transitional/components/Link';
import { Text } from 'foundations-components/components/Text';
import { useTheme } from 'foundations-theming/utils';
import { useIsPillBorderRadius } from 'portals-platform-lib';
import { jsx as _jsx } from "react/jsx-runtime";
function nodeHasChildLinks(node) {
  return Array.isArray(node.children) && node.children.length > 0;
}
const mapMenuNodesToDropdownOption = ({
  label,
  children,
  url,
  linkTarget
}, borderRadiusToken, borderRadiusCssValue) => {
  const hasChildren = Array.isArray(children) && children.length > 0;
  const isOpenInNewTab = linkTarget === '_blank';
  const dropdownStyleOverrides = {
    borderRadius: borderRadiusToken,
    '& li button': {
      // Sets border-radius on all menu item buttons
      borderRadius: `${borderRadiusCssValue} !important`,
      // Nested selector for hover/focus states of those buttons
      '&:hover, &:focus, &:focus-visible': {
        borderRadius: `${borderRadiusCssValue} !important`
      }
    }
  };
  return Object.assign({
    label: url ? /*#__PURE__*/_jsx(Link, {
      color: "text-core-default",
      href: url,
      external: isOpenInNewTab,
      target: linkTarget !== null && linkTarget !== void 0 ? linkTarget : undefined,
      children: label
    }) : /*#__PURE__*/_jsx(Text, {
      color: "text-core-default",
      as: "span",
      children: label
    }),
    options: hasChildren ? children.map(childNode => mapMenuNodesToDropdownOption(childNode, borderRadiusToken, borderRadiusCssValue)) : undefined
  }, hasChildren && {
    // Styles nested submenu containers and items
    dropdownStyles: dropdownStyleOverrides,
    // Styles nested submenu popover wrappers
    popoverProps: {
      borderRadius: borderRadiusToken
    }
  });
};
const mapMenuNodesToDropdownOptions = (nodes, borderRadiusToken, borderRadiusCssValue) => nodes.map(node => mapMenuNodesToDropdownOption(node, borderRadiusToken, borderRadiusCssValue));
export const PageLinks = () => {
  const trellisTheme = useTheme();
  const menuChildren = usePageLinks();
  const isUsingPillBorderRadius = useIsPillBorderRadius();
  const borderRadiusToken = isUsingPillBorderRadius ? '0' : '300';
  const borderRadiusCssValue = isUsingPillBorderRadius ? trellisTheme.borderRadius['0'] : trellisTheme.borderRadius['300'];
  const dropdownStyleOverrides = {
    borderRadius: borderRadiusToken,
    '& li button': {
      borderRadius: `${borderRadiusCssValue} !important`,
      '&:hover, &:focus, &:focus-visible': {
        borderRadius: `${borderRadiusCssValue} !important`
      }
    }
  };
  if (!menuChildren.length) {
    return null;
  }
  return /*#__PURE__*/_jsx(Flex, {
    alignItems: "center",
    gap: "200",
    children: menuChildren.map(node => {
      var _node$url, _node$linkTarget;
      const isOpenInNewTab = node.linkTarget === '_blank';
      const hasChildren = nodeHasChildLinks(node);
      if (hasChildren) {
        return /*#__PURE__*/_jsx(MultiLevelDropdown, {
          buttonText: /*#__PURE__*/_jsx(Text, {
            color: "text-core-default",
            children: node.label
          }),
          buttonUse: "transparent",
          options: mapMenuNodesToDropdownOptions(node.children, borderRadiusToken, borderRadiusCssValue),
          dropdownStyles: dropdownStyleOverrides,
          popoverProps: {
            borderRadius: borderRadiusToken
          },
          buttonStyles: {
            borderRadius: borderRadiusToken,
            marginBlockStart: '0'
          }
        }, node.label);
      }
      return /*#__PURE__*/_jsx(Button, {
        use: "transparent",
        href: (_node$url = node.url) !== null && _node$url !== void 0 ? _node$url : undefined,
        external: isOpenInNewTab,
        target: (_node$linkTarget = node.linkTarget) !== null && _node$linkTarget !== void 0 ? _node$linkTarget : undefined,
        marginBlockStart: "0",
        children: /*#__PURE__*/_jsx(Text, {
          color: "text-core-default",
          children: node.label
        })
      }, node.label);
    })
  });
};